import type { UserActions } from "../types";
type UserState = "unknown" | "none" | "confirming" | "authenticated";
export type State = {
  userState: UserState;
  isLoading: boolean;
  userId: string | null | undefined;
  email: string | null | undefined;
  signupErrorMessage: string | null | undefined;
};
export default function login(
  state: State = {
    userState: "unknown",
    isLoading: false,
    userId: null,
    email: null,
    signupErrorMessage: null,
  },
  action: UserActions
): State {
  switch (action.type) {
    case "LOGIN":
      return { ...state, isLoading: true };

    case "LOGOUT":
      return { ...state, isLoading: true };

    case "LOGIN_LOADED":
      return {
        isLoading: false,
        userState: action.isAuthenticated ? "authenticated" : "none",
        userId: action.userId,
        email: action.email,
        signupErrorMessage: null,
      };

    case "LOGIN_SUCCESS":
      return {
        isLoading: false,
        userState: "authenticated",
        userId: action.userId,
        email: action.email,
        signupErrorMessage: null,
      };

    case "LOGOUT_SUCCESS":
      return {
        isLoading: false,
        userState: "none",
        userId: null,
        email: null,
        signupErrorMessage: null,
      };

    case "LOGIN_FAIL":
      return {
        ...state,
        isLoading: false,
        signupErrorMessage: action.errorMessage,
      };

    case "LOGOUT_FAIL":
      return { ...state, isLoading: false };

    case "SIGNUP":
      return { ...state, isLoading: true };

    case "SIGNUP_FAIL":
      return {
        ...state,
        isLoading: false,
        signupErrorMessage: action.errorMessage,
      };

    case "SIGNUP_NEEDS_CONFIRMATION":
      return {
        userState: "confirming",
        isLoading: false,
        userId: null,
        email: null,
        signupErrorMessage: null,
      };

    case "CONFIRM_SIGNUP":
      return {
        userState: "confirming",
        isLoading: false,
        userId: null,
        email: null,
        signupErrorMessage: null,
      };
  }

  return state;
}
